import React from 'react';

interface PathProps {
  from: [number, number, number];
  to: [number, number, number];
}

export const Path: React.FC<PathProps> = ({ from, to }) => {
  const dx = to[0] - from[0];
  const dz = to[2] - from[2];
  const length = Math.sqrt(dx * dx + dz * dz);
  const angle = Math.atan2(dx, dz);

  return (
    <mesh
      position={[(from[0] + to[0]) / 2, 0.02, (from[2] + to[2]) / 2]}
      rotation={[Math.PI / 2, 0, -angle]}
    >
      <planeGeometry args={[0.5, length]} />
      <meshLambertMaterial color="#A1887F" flatShading />
    </mesh>
  );
};
